import { render, staticRenderFns } from "./PlaySport.vue?vue&type=template&id=3da1f56c&scoped=true&"
import script from "./PlaySport.vue?vue&type=script&lang=js&"
export * from "./PlaySport.vue?vue&type=script&lang=js&"
import style0 from "./PlaySport.vue?vue&type=style&index=0&id=3da1f56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da1f56c",
  null
  
)

export default component.exports